export const CreateRecordConstants = {
  START_DATE: "audiences.startDate",
  FINISH_DATE: "audiences.endDate",
  STATUS: "audiences.status.title",
  ACTIVE: "common.active",
  HEARING_NUMBER: "audiences.procedureNumber",
  SEARCH: "common.search",
  CLEAR: "common.clear",
  PARTICIPANTS: "participants.singular",
};

export type SearchScope = "general" | "current" | "county";
export interface FilterExtras {
  attendantId?: number | null;
  profile?: any;
  scope?: SearchScope;
}
